import { PropsWithChildren } from 'react';
import Appbar from '@components/Layout/Appbar';

export default function LayoutAppbarOnly({ children }: PropsWithChildren) {
  return (
    <div className="flex flex-col min-h-screen">
      <Appbar />

      <main
        className={`flex flex-col items-center justify-center flex-1 p-main mt-navbarHeight`}
      >
        {children}
      </main>
    </div>
  );
}
